import angular from 'angular';
import grid from 'angular-ui-grid';

export class ProductBarcodesController {

  closeWindow: Function;

  data;
  options;
  grid;

  /*@ngInject*/
  constructor($scope, Storage, WindowService) {
    this.Storage = Storage;
    this.scope   = $scope;

    this.closeWindow = WindowService.delItem;
    this.scope.deleteRow = this.deleteRow.bind(this);
  }

  $onInit() {

    return this.Storage.loadBarcodes(this.data.product._id)
      .then((barcodes) => {

        this.options = {
          primaryKey: '_id',
          enableCellSelection: false,
          enableCellEdit: false,
          enableCellEditOnFocus: false,
          enableColumnResize: true,
          enableColumnReordering: false,
          enableSorting: false,
          enableRowSelection: true,
          showGroupPanel: false,
          multiSelect: false,
          data: barcodes,
          onRegisterApi: (gridApi) => {
            this.grid = gridApi;

            this.grid.edit.on.afterCellEdit(this.scope, (rowEntity, colDef, newValue, oldValue) => {
              
              if(oldValue  == newValue) {
                return false;
              }

              return this.Storage.saveBarcode(rowEntity)
                .then(() => {
                  this.grid.rowEdit.setRowsClean([rowEntity]);
                });
            });
          },
          columnDefs: [{
            displayName: '#',
            field: '_id',
            groupable: false,
            resizable: false,
            sortable: false,
            visible: false,
            width: 50
          }, {
            displayName: 'Данные',
            field: 'barcode',
            groupable: false,
            resizable: true,
            sortable: true,
            visible: true,
            width: 150,
          }, {
            displayName: 'Штрихкод',
            field: 'image',
            groupable: true,
            resizable: true,
            sortable: true,
            visible: true,
            cellEditableCondition: function(){ return false; },
          }, {
            displayName: '#',
            field: 'status',
            width: 50,
            cellTemplate: '<span style="padding:5px;"><a href="javascript:;" ng-show="row.entity._id" ng-click="grid.appScope.deleteRow(row.entity)"><span class="glyphicon glyphicon-remove" aria-hidden="true"></span></a></span>',
            cellEditableCondition: function(){ return false; },
          }]
        };
      });
  }

  deleteRow(barcode) {
    return this.Storage.removeBarcode(barcode)
      .then(() => {
        // @TODO: need normal messages
      })
      .catch(err => {
        console.error(err);
      });
  }

  close() {
    this.closeWindow(this.data.id);
  }
}



export default angular.module('storageApp.product.barcodes', [
    grid,
    grid + '.selection',
    grid + '.edit',
    grid + '.rowEdit',
    grid + '.saveState',
    grid + '.grouping',

    //
  ])
  .component('productBarcodes', {
    bindings: {data: '='},
    template: require('./product-barcodes.html'),
    transclude: true,
    controller: ProductBarcodesController
  })
  .name;



// WEBPACK FOOTER //
// ./client/app/product-barcodes/product-barcodes.component.js